import { render, staticRenderFns } from "./QutaRawMater.vue?vue&type=template&id=c5638eae&scoped=true&"
import script from "./QutaRawMater.vue?vue&type=script&lang=js&"
export * from "./QutaRawMater.vue?vue&type=script&lang=js&"
import style0 from "./QutaRawMater.vue?vue&type=style&index=0&id=c5638eae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5638eae",
  null
  
)

export default component.exports